// extracted by mini-css-extract-plugin
export default {"buttonContainer":"WearerSettings_buttonContainer__ZYKKu","editButton":"WearerSettings_editButton__Xz-Wh","cardContainer":"WearerSettings_cardContainer__tLTsT"};